// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1C2rl","log":"ModalInventoryLogs_log__OKzkY","date":"ModalInventoryLogs_date__19u8W","userName":"ModalInventoryLogs_userName__1TluA"};